import {
  Avatar,
  Box,
  Checkbox,
  Chip,
  Fab,
  Grid,
  IconButton,
  Paper,
  Tab,
  TableRow,
  tabsClasses,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  create_organisation_paymentRequest,
  get_all_organisations,
  get_company_member_list,
  get_company_members_summary,
  update_company_member,
  validate_bulk_import,
  bulk_import_members,
} from "../Redux/Actions/action";
import { showLoader } from "../Redux/Slices/loaderSlice";
import CommonSearchField from "../Components/Common/CommonSearchField";
import CommonTable from "../Components/Common/CommonTable";
import StyledTableCell from "../Components/Common/styledTableCell";
import ErrorHandler, {
  capitalizeFirstLetterOfWords,
  checkAccess,
  CommonChip,
} from "../Utils/handler";
import CustomPagination from "../Components/Common/CommonPagination";
import { BucketURL } from "../ApiSetup/Api";
import { TabContext, TabList } from "@mui/lab";
import DataNotFound from "../Components/Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import dayjs from "dayjs";
import CustomDialog from "../Components/Common/CustomDialog";
import ButtonContained from "../Components/Common/ButtonContained";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import sessionStoreUtil from "../ApiSetup/Localstorage";
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, LinearProgress } from "@mui/material";
import * as XLSX from "xlsx";

const useStyles = makeStyles()((theme) => ({
  TabList: {
    "& .Mui-selected": {
      fontWeight: "bold",
    },
  },
  TabDesign: {
    backgroundColor: "transparent",
    borderRadius: "6px",
    color: "#3E4094",
    minHeight: "40px",
    maxHeight: "50px",
    minWidth: "auto",
    "&.Mui-selected": {
      backgroundColor: theme?.palette?.bgLightWeight?.main,
    },
  },
}));

function OrganisationMembers() {
  // ---------- Hook -----------
  const { classes } = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const sm = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dataAccess = useSelector(
    (value) => value?.allAvailableAccess?.AllAvailableAccessList
  );
  const availableAccess = dataAccess?.filter((e) => e.path === pathname)?.[0]
    ?.actionsType;
  const user = sessionStoreUtil.getLSItem("userData")
    ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
    : {};

  const [searchParams, setSearchParams] = useSearchParams();

  // --------------- State -------------
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [tableData, setTableData] = useState({});
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [membersSummary, setMembersSummary] = useState();
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [isAssignedModal, setIsAssignedModal] = useState(false);
  const [sorting, setSorting] = useState({
    isPpskId: "",
    isSubmittedDate: "",
    isUpdatedDate: "",
    isRenewDays: "",
    isVerifyBy: "",
    isPaymentDate: ""
  });
  const [isSearch, setIsSearch] = useState(false);

  // Bulk Import States
  const [isBulkImportOpen, setIsBulkImportOpen] = useState(false);
  const [importData, setImportData] = useState([]);
  const [validatedData, setValidatedData] = useState(null);
  const [importStep, setImportStep] = useState(1); // 1: Upload, 2: Preview, 3: Result
  const [importResult, setImportResult] = useState(null);

  const isSelected = (id) => selectedMembers?.indexOf(id) !== -1;

  const tabData = [
    {
      label: "Pending",
      value: "0",
      tabLabel: "Pending Tab",
      isView: true,
      color: theme.palette.primary.main
    },
    {
      label: "Completed",
      value: "1",
      tabLabel: "Completed Tab",
      isView: true,
      color: theme.palette.warning.main
    },
    {
      label: "Approved",
      value: "2",
      tabLabel: "Approved Tab",
      isView: true,
      color: "rgba(11, 176, 108, 1)"
    },
    {
      label: "Rejected",
      value: "3",
      tabLabel: "Rejected Tab",
      isView: true,
      color: "rgba(227, 54, 41, 1)"
    },
    {
      label: "Partial-Rejected",
      value: "4",
      tabLabel: "Partial-Rejected Tab",
      isView: true,
      color: "rgba(252, 171, 17, 1)"
    },
    {
      label: "Re-Upload",
      value: "5",
      tabLabel: "Re-Upload Tab",
      isView: true,
      color: "rgba(245, 134, 52, 1)"
    },
    {
      label: "Submit-To-Office",
      value: "6",
      tabLabel: "Submit-To-Office Tab",
      isView: true,
      color: "rgba(2, 88, 100, 1)"
    },
    {
      label: "Payment Request",
      value: "7",
      tabLabel: "Payment Request Tab",
      isView: true,
      color: theme.palette.panddingPaymant?.main || "#9c27b0"
    },
    {
      label: "Verified Payers",
      value: "8",
      tabLabel: "Verified Payers Tab",
      isView: true,
      color: theme.palette.info.main
    },
  ];

  const urlTab = searchParams.get("tab");
  const urlOrg = searchParams.get("org");
  
  const getDefaultTab = () => {
    const viewableTab = tabData.find((tab) => tab.isView);
    return viewableTab?.value || tabData[0]?.value || "0";
  };
  
  const defaultTab = getDefaultTab();
  const initialTab = tabData?.some((tab) => tab.value === urlTab) ? urlTab : defaultTab;

  const [tabValue, setTabValue] = useState(initialTab);
  const [value, setValue] = useState(initialTab);

  // --------------- handleChange ---------------
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const viewHandler = (item) => {
    navigate(`/admin/documents-view?id=${item._id}`);
  };

  const _generateExcel = (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    const headerRowValues = [
      "No",
      "PPSK Id",
      "Name",
      "Contact No.",
      "Organisation",
      "Gender",
      "Submitted Date",
      "Updated Date",
      "Status",
      "Payment Status",
    ];
    const headerRow = worksheet.addRow(headerRowValues);

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "3e4094" },
      };
      cell.font = { bold: true, color: { argb: "FFFFFF" } };
    });

    data?.forEach((document, index) => {
      worksheet.addRow([
        index + 1,
        document?.ppskId || "-",
        document?.fullName || "-",
        document?.phoneNumber || "-",
        document?.organisationName || "-",
        document?.personalDetails?.gender || "-",
        dayjs(document?.createdAt).format("ll") || "-",
        dayjs(document?.updatedAt).format("ll") || "-",
        document?.verificationStatus || "-",
        document?.policyStatus?.transaction?.status || "-",
      ]);
    });

    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 40 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(
          data,
          `Organisation_Members_${selectedOrg || 'All'}_${dayjs(new Date()).format("DD-MM-YYYY")}.xlsx`
        );
      })
      .catch((err) => {
        console.error("Error generating Excel:", err);
      });
  };

  // --------------- Api  ---------------
  const _getAllOrganisations = async () => {
    dispatch(showLoader(true));
    try {
      const result = await dispatch(get_all_organisations());
      const error = ErrorHandler(result);
      if (error) {
        setOrganisations(result?.payload?.data?.organisations || []);
        // Set initial organisation from URL or first available
        if (urlOrg) {
          setSelectedOrg(urlOrg);
        } else if (result?.payload?.data?.organisations?.length > 0) {
          setSelectedOrg(result?.payload?.data?.organisations[0]?.name);
        }
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getDocumetsData = async () => {
    if (!selectedOrg) return;
    
    dispatch(showLoader(true));
    const verificationStatus =
      value === "0"
        ? "Pending"
        : value === "1"
          ? "Completed"
          : value === "2"
            ? "Approved"
            : value === "3"
              ? "Rejected"
              : value === "4"
                ? "Partial-Rejected"
                : value === "5"
                  ? "Re-Upload"
                  : value === "6"
                    ? "Submit-To-Office"
                    : value === "7"
                      ? "Payment Request"
                      : value === "8"
                        ? "Verified Payers"
                        : "";
    let body = {
      search: searchText || "",
      page: page,
      limit: rowsPerPage,
      verificationStatus: verificationStatus,
      orgName: selectedOrg,
      isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
      isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
      isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
      isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
      isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : "",
      isPaymentDate: sorting?.isPaymentDate ? +sorting?.isPaymentDate : "",
    };

    try {
      const result = await dispatch(get_company_member_list(body));
      const error = ErrorHandler(result);
      if (error) {
        setTableData(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getSummaryDetails = async () => {
    if (!selectedOrg) return;
    
    dispatch(showLoader(true));
    let body = { orgName: selectedOrg };
    try {
      const result = await dispatch(get_company_members_summary(body));
      const error = ErrorHandler(result);
      if (error) {
        setMembersSummary(result?.payload?.data?.counts);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _downloadMembers = async () => {
    if (!selectedOrg) return;
    
    dispatch(showLoader(true));
    const verificationStatus =
      value === "0"
        ? "Pending"
        : value === "1"
          ? "Completed"
          : value === "2"
            ? "Approved"
            : value === "3"
              ? "Rejected"
              : value === "4"
                ? "Partial-Rejected"
                : value === "5"
                  ? "Re-Upload"
                  : value === "6"
                    ? "Submit-To-Office"
                    : value === "7"
                      ? "Payment Request"
                      : value === "8"
                        ? "Verified Payers"
                        : "";
    let body = {
      search: searchText || "",
      verificationStatus: verificationStatus,
      orgName: selectedOrg,
      isPpskId: sorting?.isPpskId ? +sorting?.isPpskId : "",
      isSubmittedDate: sorting?.isSubmittedDate ? +sorting?.isSubmittedDate : "",
      isUpdatedDate: sorting?.isUpdatedDate ? +sorting?.isUpdatedDate : "",
      isRenewDays: sorting?.isRenewDays ? +sorting?.isRenewDays : "",
      isVerifyBy: sorting?.isVerifyBy ? +sorting?.isVerifyBy : "",
      isPaymentDate: sorting?.isPaymentDate ? +sorting?.isPaymentDate : "",
    };
    try {
      const result = await dispatch(get_company_member_list(body));
      const error = ErrorHandler(result);
      if (error) {
        _generateExcel(result?.payload?.data?.members);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const handleClick = (event, id) => {
    event.stopPropagation();
    const selectedIndex = selectedMembers?.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedMembers, id);
    } else {
      newSelected = selectedMembers?.filter((item) => item !== id);
    }
    setSelectedMembers(newSelected);
  };

  const handleCheckboxClick = (event, id) => {
    event.stopPropagation();
    handleClick(event, id);
  };

  // Bulk Import Functions
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        // Map Excel columns to expected format
        const mappedData = jsonData.map((row) => ({
          fullName: row["Full Name"] || row["fullName"] || "",
          phoneNumber: row["Phone Number"] || row["phoneNumber"] || "",
          email: row["Email"] || row["email"] || "",
          dob: row["Date of Birth"] || row["dob"] || "",
          gender: row["Gender"] || row["gender"] || "",
          aadharNumber: row["Aadhaar Number"] || row["aadharNumber"] || "",
          fatherName: row["Father's Name"] || row["fatherName"] || "",
          motherName: row["Mother's Name"] || row["motherName"] || "",
          address: row["Address"] || row["address"] || "",
          city: row["City"] || row["city"] || "",
          state: row["State"] || row["state"] || "",
          pincode: row["Pincode"] || row["pincode"] || "",
          occupation: row["Occupation"] || row["occupation"] || "",
          nomineeName: row["Nominee Name"] || row["nomineeName"] || "",
          nomineeRelation: row["Nominee Relation"] || row["nomineeRelation"] || "",
          nomineePhone: row["Nominee Phone"] || row["nomineePhone"] || "",
        }));

        setImportData(mappedData);
        setImportStep(2);
      } catch (error) {
        toast.error("Failed to parse Excel file");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleValidateImport = async () => {
    if (!selectedOrg) {
      toast.error("Please select an organisation first");
      return;
    }

    dispatch(showLoader(true));
    try {
      const result = await dispatch(validate_bulk_import({
        data: importData,
        organisationName: selectedOrg,
      }));
      const error = ErrorHandler(result);
      if (error) {
        setValidatedData(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error?.message || "Validation failed");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const handleExecuteImport = async () => {
    if (!validatedData?.validData?.length) {
      toast.error("No valid data to import");
      return;
    }

    dispatch(showLoader(true));
    try {
      const result = await dispatch(bulk_import_members({
        members: validatedData.validData,
        organisationName: selectedOrg,
        verificationStatus: "Pending",
      }));
      const error = ErrorHandler(result);
      if (error) {
        setImportResult(result?.payload?.data);
        setImportStep(3);
        toast.success(`Successfully imported ${result?.payload?.data?.successCount} members`);
        // Refresh data
        _getDocumetsData();
        _getSummaryDetails();
        _getAllOrganisations();
      }
    } catch (error) {
      toast.error(error?.message || "Import failed");
    } finally {
      dispatch(showLoader(false));
    }
  };

  const downloadTemplate = () => {
    const templateData = [
      {
        "Full Name": "John Doe",
        "Phone Number": "9876543210",
        "Email": "john@example.com",
        "Date of Birth": "1990-01-15",
        "Gender": "Male",
        "Aadhaar Number": "123456789012",
        "Father's Name": "Father Name",
        "Mother's Name": "Mother Name",
        "Address": "123 Main Street",
        "City": "Surat",
        "State": "Gujarat",
        "Pincode": "395001",
        "Occupation": "Business",
        "Nominee Name": "Nominee Name",
        "Nominee Relation": "Spouse",
        "Nominee Phone": "9876543211",
      },
    ];

    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Members");
    XLSX.writeFile(wb, "bulk_import_template.xlsx");
  };

  const resetBulkImport = () => {
    setIsBulkImportOpen(false);
    setImportData([]);
    setValidatedData(null);
    setImportStep(1);
    setImportResult(null);
  };

  // --------- useEffect ----------
  useEffect(() => {
    _getAllOrganisations();
  }, []);

  useEffect(() => {
    if (selectedOrg) {
      _getSummaryDetails();
    }
  }, [value, selectedOrg]);

  useEffect(() => {
    if (selectedOrg) {
      _getDocumetsData();
    }
  }, [page, rowsPerPage, value, searchText, sorting, selectedOrg]);

  useEffect(() => {
    const params = { tab: tabValue };
    if (selectedOrg) params.org = selectedOrg;
    setSearchParams(params);
  }, [tabValue, selectedOrg, setSearchParams]);

  const tableHeaders = [
    (value == "0" || value == "1" || value == "2") ? (
      <Checkbox
        key="select-all-checkbox"
        color="success"
        indeterminate={
          selectedMembers.length > 0 &&
          selectedMembers.length < tableData?.members?.length
        }
        checked={
          tableData?.members?.length > 0 &&
          selectedMembers?.length === tableData?.members?.length
        }
        onChange={(event) => {
          const newSelected = event.target.checked
            ? tableData?.members?.map((item) => item._id)
            : [];
          setSelectedMembers(newSelected);
        }}
        sx={{ "& .MuiSvgIcon-root": { color: "#ffffff" } }}
      />
    ) : value == "8" ? " " : "",
    "No",
    "Photo",
    "PPSK ID",
    "Name",
    "Mobile No",
    "Organisation",
    "Gender",
    "Added By",
    "Family Members",
    "Submitted Date",
    value === "8" && "Expired At",
    "Updated Date",
    value === "2" && "Payment",
    value === "2" && "Payment Date",
    value === "2" && "Start Date",
    value === "2" && "End Date",
    value === "2" && "Remaining Renew Days",
    value === "2" && "Verified By",
    (checkAccess(pathname, dataAccess, "Action View") ||
      checkAccess(pathname, dataAccess, "Action Edit")) &&
    "Action",
  ]?.filter(Boolean);

  return (
    <Grid container spacing={2} xs={12} sm={12} md={12} lg={12}>
      <Grid item xs={12}>
        <Paper
          elevation={0}
          sx={{ padding: 2, background: { md: "#fff", xs: "none" }, borderRadius: '20px', border: `1px solid lightgrey` }}
        >
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={{ sm: "center", xs: "start" }}
            mb={2}
            gap={2}
            flexDirection={{ sm: "row", xs: "column" }}
          >
            <Typography
              sx={{ fontSize: { lg: 24, md: 20, xs: 18 } }}
              fontWeight={"medium"}
              color={"#3E4094"}
            >
              Organisation Members
            </Typography>
            
            <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
              {/* Organisation Selector */}
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>Select Organisation</InputLabel>
                <Select
                  value={selectedOrg}
                  label="Select Organisation"
                  onChange={(e) => {
                    setSelectedOrg(e.target.value);
                    setPage(1);
                    setSelectedMembers([]);
                  }}
                >
                  {organisations.map((org) => (
                    <MenuItem key={org.name} value={org.name}>
                      {org.displayName || org.name} ({org.memberCount})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* Bulk Import Button */}
              <Button
                variant="outlined"
                startIcon={<CloudUploadIcon />}
                onClick={() => {
                  if (!selectedOrg) {
                    toast.error("Please select an organisation first");
                    return;
                  }
                  setIsBulkImportOpen(true);
                }}
                disabled={!selectedOrg}
              >
                Bulk Import
              </Button>
            </Box>
          </Box>

          <Box
            display={"flex"}
            justifyContent={"end"}
            alignItems={{ sm: "center", xs: "start" }}
            mb={1}
            gap={1}
            flexDirection={{ sm: "row", xs: "column" }}
          >
            <Tooltip title={`Search`}>
              {!isSearch &&
                <Fab sx={{
                  width: '46px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, border: '1px solid rgba(34, 34, 34, 0.3)', borderRadius: '10px', backgroundColor: "transparent", color: "rgba(34, 34, 34, 0.3)",
                }} onClick={() => setIsSearch(true)}>
                  <SearchIcon sx={{ fontSize: '24px' }} />
                </Fab>
              }
              {isSearch &&
                <CommonSearchField placeholder={"Search.."} tooltipList={['Name', "AadharCard Number", "Mobile Number"]} handleSearch={(e) => { setPage(1); setSearchText(e); }} />
              }
            </Tooltip>
            <Tooltip title={`Download Members`}>
              <Fab disabled={tableData?.members?.length === 0 || !selectedOrg} color='primary' sx={{
                width: '56px', height: '42px', boxShadow: 'none', minHeight: "30px", padding: 0, borderRadius: '10px', backgroundColor: tabData?.filter((e) => e?.value == tabValue)?.[0]?.color, color: theme.palette.common.white, "&:hover": {
                  background: tabData?.filter((e) => e?.value == tabValue)?.[0]?.color, color: theme.palette.common.white
                }
              }} onClick={() => _downloadMembers()}>
                <FileDownloadOutlinedIcon sx={{ fontSize: '24px' }} />
              </Fab>
            </Tooltip>
          </Box>

          {(value == "0" || value == "1" || value == "2" || value == "8") && (
            <Grid
              item
              xs={12}
              display={"flex"}
              gap={"10px"}
              justifyContent={"flex-end"}
              alignItems={"center"}
              mb={2}
            >
              <ButtonContained
                text={
                  value === "0"
                    ? "Move to Completed"
                    : value === "1"
                      ? "Move to PPSK Office"
                      : "Move to Payment Request"
                }
                fontSize={{ xs: "13px", md: "14px" }}
                height={"35px"}
                onClick={() => setIsAssignedModal(true)}
                disabled={selectedMembers.length > 0 ? false : true}
              />
            </Grid>
          )}

          <TabContext value={value}>
            <Box mb={1}>
              <TabList
                onChange={(e, newValue) => {
                  setValue(newValue);
                  setPage(1);
                  setTabValue(newValue);
                  setSelectedMembers([]);
                  setSorting({
                    isPpskId: "",
                    isSubmittedDate: "",
                    isUpdatedDate: "",
                    isRenewDays: "",
                    isVerifyBy: "",
                    isPaymentDate: ""
                  })
                }}
                aria-label="tabs with icons"
                sx={{
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                  "& .Mui-selected": {
                    background: tabData?.filter((e) => e?.value == tabValue)?.[0]?.color,
                    color: `${theme.palette.common.white} !important`
                  },
                  [`& .${tabsClasses.scrollButtons}`]: {
                    '&.Mui-disabled': { opacity: 0.3 },
                  }
                }}
                variant="scrollable"
                scrollButtons="auto"
              >
                {tabData?.map((tab, index) => {
                  return (
                    <Tab
                      key={tab?.value || index}
                      label={`${tab?.label} (${membersSummary?.find(
                        (e) => e?.status == tab?.label
                      )?.statusCount || 0
                        })`}
                      value={tab?.value}
                      sx={{ marginRight: '10px', border: `2px solid ${tab.color}`, borderRadius: '10px', color: tab.color, height: '40px', minHeight: '0px' }}
                    />
                  );
                })}
              </TabList>
            </Box>
          </TabContext>

          {!selectedOrg ? (
            <Box py={4} textAlign="center">
              <Typography color="textSecondary">
                Please select an organisation to view members
              </Typography>
            </Box>
          ) : (
            <>
              <CommonTable
                headerList={tableHeaders}
                align={"center"}
                minWidth={600}
                setSorting={setSorting} sorting={sorting}
                backgroundColor={tabData?.filter((e) => e?.value == tabValue)?.[0]?.color}
              >
                {tableData?.members?.length > 0 ? (
                  tableData?.members?.map((document, index) => {
                    let image = document?.personalDetails?.image
                      ? BucketURL + document?.personalDetails?.image
                      : "No";
                    const isItemSelected = isSelected(document?._id);
                    return (
                      <TableRow key={index}>
                        {(value == "0" || value == "1" || value == "2" || value == "8") && (
                          <StyledTableCell align="center">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              onChange={(event) =>
                                handleCheckboxClick(event, document?._id)
                              }
                              sx={{
                                "& .MuiSvgIcon-root": { color: "#666666" },
                                opacity:
                                  value == "8" && !document?.isShowExpireAt
                                    ? 0.5
                                    : 1,
                              }}
                              disabled={value == "8" && !document?.isShowExpireAt}
                            />
                          </StyledTableCell>
                        )}
                        <StyledTableCell
                          sx={{
                            position: "relative",
                            padding: "0px",
                            width: "75px",
                          }}
                          align="center"
                        >
                          <Box>
                            {(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}
                          </Box>
                        </StyledTableCell>

                        <StyledTableCell align="center" >
                          <Box display={'flex'} justifyContent={'center'}>
                            <Avatar src={image} slotProps={{ img: { loading: 'lazy', } }} sx={{ borderRadius: '6px' }} />
                          </Box>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {document?.ppskId}
                        </StyledTableCell>
                        <StyledTableCell align="center">{capitalizeFirstLetterOfWords(document?.fullName || "-")}</StyledTableCell>
                        <StyledTableCell align="center">{document?.phoneNumber ? document?.phoneNumber : document?.personalDetails?.phoneNumber ? document?.personalDetails?.phoneNumber : "-"}</StyledTableCell>
                        <StyledTableCell align="center">
                          <Chip 
                            label={document?.organisationName || "-"} 
                            size="small" 
                            color="primary" 
                            variant="outlined"
                          />
                        </StyledTableCell>
                        <StyledTableCell align="center">{document?.personalDetails?.gender || "-"}</StyledTableCell>
                        <StyledTableCell align="center">
                          {document?.addedByUser ? (
                            <Tooltip title={`Created by: ${document?.addedByUser?.phoneNumber || ''}`}>
                              <span style={{ cursor: 'pointer' }}>
                                {capitalizeFirstLetterOfWords(document?.addedByUser?.fullName || "-")}
                              </span>
                            </Tooltip>
                          ) : document?.linkedByUsers?.length > 0 ? (
                            <Tooltip 
                              title={
                                <Box>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    Linked by:
                                  </Typography>
                                  {document?.linkedByUsers?.map((user, idx) => (
                                    <Box key={idx} sx={{ mb: 0.5 }}>
                                      • {user?.fullName || 'N/A'} ({user?.phoneNumber || 'N/A'})
                                    </Box>
                                  ))}
                                </Box>
                              }
                            >
                              <Chip 
                                label={`Linked by ${document?.linkedByUsers?.length}`}
                                size="small"
                                color="secondary"
                                variant="outlined"
                                sx={{ cursor: 'pointer' }}
                              />
                            </Tooltip>
                          ) : (
                            <span style={{ color: '#888' }}>Self</span>
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {document?.familyMemberCount > 0 ? (
                            <Tooltip 
                              title={
                                <Box>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                    Linked Family Members:
                                  </Typography>
                                  {document?.linkedFamilyMembers?.map((member, idx) => (
                                    <Box key={idx} sx={{ mb: 0.5 }}>
                                      • {member?.fullName || 'N/A'} ({member?.phoneNumber || 'N/A'})
                                      <Chip 
                                        label={member?.verificationStatus || 'N/A'} 
                                        size="small" 
                                        sx={{ ml: 1, height: '18px', fontSize: '10px' }}
                                      />
                                    </Box>
                                  ))}
                                </Box>
                              }
                            >
                              <Chip 
                                label={`${document?.familyMemberCount} member${document?.familyMemberCount > 1 ? 's' : ''}`}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={{ cursor: 'pointer' }}
                              />
                            </Tooltip>
                          ) : (
                            <span style={{ color: '#888' }}>-</span>
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="center">{dayjs(document?.createdAt).format("ll") || "-"}</StyledTableCell>
                        {value === "8" && (
                          <StyledTableCell align="center">
                            {document?.policyStatus?.expireAt
                              ? dayjs(document?.policyStatus?.expireAt).format("ll")
                              : "-"}
                          </StyledTableCell>
                        )}
                        <StyledTableCell align="center">{dayjs(document?.updatedAt).format("ll") || "-"}</StyledTableCell>
                        {value === "2" && (
                          <>
                            <StyledTableCell align="center">
                              <CommonChip
                                label={document?.policyStatus?.transaction?.status || "-"}
                                status={document?.policyStatus?.transaction?.status}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {document?.policyStatus?.transaction?.transactionDate
                                ? dayjs(document?.policyStatus?.transaction?.transactionDate).format("ll")
                                : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {document?.policyStatus?.activeAt
                                ? dayjs(document?.policyStatus?.activeAt).format("ll")
                                : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {document?.policyStatus?.expireAt
                                ? dayjs(document?.policyStatus?.expireAt).format("ll")
                                : "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {document?.policyStatus?.remainingRenewDays || "-"}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {document?.documentVerificationStatus?.verifiedBy || "-"}
                            </StyledTableCell>
                          </>
                        )}
                        {(checkAccess(pathname, dataAccess, "Action View") ||
                          checkAccess(pathname, dataAccess, "Action Edit")) && (
                            <StyledTableCell
                              align="center"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                justifyContent: "center",
                              }}
                            >
                              <Tooltip title="View Details">
                                <IconButton
                                  sx={{
                                    padding: 0.5, "&:hover": {
                                      border: "1px solid rgba(62, 64, 149, 1)",
                                      background: "rgba(215, 223, 255, 1)",
                                      borderRadius: "10px"
                                    }
                                  }}
                                  onClick={() => viewHandler(document)}
                                >
                                  <VisibilityIcon
                                    fontSize="medium"
                                    color="primary"
                                  />
                                </IconButton>
                              </Tooltip>
                            </StyledTableCell>
                          )}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <StyledTableCell colSpan={tableHeaders.length}>
                      <DataNotFound
                        title={"No Records Found"}
                        icon={
                          <ErrorOutlineIcon
                            color="primary"
                            style={{ fontSize: "3rem" }}
                          />
                        }
                        elevation={0}
                      />
                    </StyledTableCell>
                  </TableRow>
                )}
              </CommonTable>
              {tableData?.count > 0 && (
                <Grid item xs={12}>
                  <CustomPagination
                    rowsPerPageOptions={[25, 50, 100]}
                    count={Math.ceil(tableData?.count / rowsPerPage)}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Grid>
              )}
            </>
          )}
        </Paper>
      </Grid>

      {/* Confirmation Modal */}
      <CustomDialog
        open={isAssignedModal}
        onClose={() => setIsAssignedModal(false)}
        title={`Confirm Action`}
        maxWidth="sm"
      >
        <Box p={2}>
          <Typography mb={2}>
            Are you sure you want to move {selectedMembers.length} member(s) to{" "}
            {value === "0"
              ? "Completed"
              : value === "1"
                ? "Submit-To-Office"
                : "Payment Request"}
            ?
          </Typography>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <ButtonContained
              text="Cancel"
              onClick={() => setIsAssignedModal(false)}
              color="secondary"
            />
            <ButtonContained
              text="Confirm"
              onClick={async () => {
                dispatch(showLoader(true));
                try {
                  let body = {
                    verificationStatus:
                      value == "0"
                        ? "Completed"
                        : value == "1"
                          ? "Submit-To-Office"
                          : "Payment Request",
                    memberIds: selectedMembers,
                  };
                  const result = await dispatch(update_company_member(body));
                  const error = ErrorHandler(result);
                  if (error) {
                    toast.success(result?.payload?.message);
                    setSelectedMembers([]);
                    setIsAssignedModal(false);
                    _getDocumetsData();
                    _getSummaryDetails();
                    if (value == "2" || value == "8") {
                      let paymentBody = {
                        userIds: selectedMembers,
                      };
                      await dispatch(create_organisation_paymentRequest(paymentBody));
                    }
                  }
                } catch (error) {
                  toast.error(error?.message || "An unknown error occurred");
                } finally {
                  dispatch(showLoader(false));
                }
              }}
            />
          </Box>
        </Box>
      </CustomDialog>

      {/* Bulk Import Modal */}
      <Dialog open={isBulkImportOpen} onClose={resetBulkImport} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              Bulk Import Members to {selectedOrg}
            </Typography>
            <Chip
              label={`Step ${importStep} of 3`}
              color="primary"
              size="small"
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          {/* Step 1: Upload */}
          {importStep === 1 && (
            <Box>
              <Alert severity="info" sx={{ mb: 2 }}>
                Upload an Excel file (.xlsx) with member data for <strong>{selectedOrg}</strong>. Download the template to see the required format.
              </Alert>

              <Box display="flex" gap={2} mb={3}>
                <Button
                  variant="outlined"
                  startIcon={<DownloadIcon />}
                  onClick={downloadTemplate}
                >
                  Download Template
                </Button>
              </Box>

              <Box
                sx={{
                  border: '2px dashed',
                  borderColor: 'primary.main',
                  borderRadius: 2,
                  p: 4,
                  textAlign: 'center',
                  cursor: 'pointer',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
                component="label"
              >
                <input
                  type="file"
                  hidden
                  accept=".xlsx,.xls"
                  onChange={handleFileUpload}
                />
                <CloudUploadIcon sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
                <Typography variant="h6">Click to upload Excel file</Typography>
                <Typography variant="body2" color="textSecondary">
                  Supports .xlsx and .xls files
                </Typography>
              </Box>
            </Box>
          )}

          {/* Step 2: Preview & Validate */}
          {importStep === 2 && (
            <Box>
              <Alert severity="info" sx={{ mb: 2 }}>
                {importData.length} records found for <strong>{selectedOrg}</strong>. Validate data before import.
              </Alert>

              <Box display="flex" gap={2} mb={2}>
                <Button
                  variant="contained"
                  onClick={handleValidateImport}
                >
                  Validate Data
                </Button>
              </Box>

              {validatedData && (
                <Box>
                  <Box display="flex" gap={2} mb={2}>
                    <Chip
                      icon={<CheckCircleIcon />}
                      label={`Valid: ${validatedData.validCount}`}
                      color="success"
                    />
                    <Chip
                      icon={<CancelIcon />}
                      label={`Errors: ${validatedData.errorCount}`}
                      color="error"
                    />
                  </Box>

                  {validatedData.errors?.length > 0 && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      <Typography variant="subtitle2" fontWeight="bold">Errors:</Typography>
                      {validatedData.errors.slice(0, 5).map((err, idx) => (
                        <Typography key={idx} variant="body2">
                          Row {err.row}: {err.errors.join(", ")}
                        </Typography>
                      ))}
                      {validatedData.errors.length > 5 && (
                        <Typography variant="body2">...and {validatedData.errors.length - 5} more errors</Typography>
                      )}
                    </Alert>
                  )}

                  {validatedData.validCount > 0 && (
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleExecuteImport}
                      sx={{ mt: 2 }}
                    >
                      Import {validatedData.validCount} Valid Records
                    </Button>
                  )}
                </Box>
              )}

              {/* Preview Table */}
              <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>Preview (First 5 rows):</Typography>
              <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                  <thead>
                    <tr style={{ background: theme.palette.primary.main, color: 'white' }}>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Name</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Phone</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Email</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Gender</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>City</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importData.slice(0, 5).map((row, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.fullName}</td>
                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.phoneNumber}</td>
                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.email}</td>
                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.gender}</td>
                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.city}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Box>
          )}

          {/* Step 3: Result */}
          {importStep === 3 && importResult && (
            <Box textAlign="center" py={4}>
              <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>Import Complete!</Typography>
              <Box display="flex" justifyContent="center" gap={2} mb={3}>
                <Chip
                  icon={<CheckCircleIcon />}
                  label={`Success: ${importResult.successCount}`}
                  color="success"
                  size="large"
                />
                <Chip
                  icon={<CancelIcon />}
                  label={`Failed: ${importResult.failedCount}`}
                  color="error"
                  size="large"
                />
              </Box>
              {importResult.failed?.length > 0 && (
                <Alert severity="warning" sx={{ textAlign: 'left', mt: 2 }}>
                  <Typography variant="subtitle2" fontWeight="bold">Failed Records:</Typography>
                  {importResult.failed.slice(0, 5).map((fail, idx) => (
                    <Typography key={idx} variant="body2">
                      {fail.data?.fullName}: {fail.error}
                    </Typography>
                  ))}
                </Alert>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {importStep === 2 && (
            <Button onClick={() => { setImportStep(1); setImportData([]); setValidatedData(null); }}>
              Back
            </Button>
          )}
          <Button onClick={resetBulkImport}>
            {importStep === 3 ? "Close" : "Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default OrganisationMembers;
